<template>
  <JoszakiAutocomplete
    :value="value"
    v-bind="$attrs"
    icon="user-friends"
    :items="filteredPartners"
    :loading="loading"
    @search="onSearch"
    @focus="onFocus"
    @input="$emit('input', $event)"
    v-on="$listeners"
  >
    <template #empty>
      {{ $t("conductor.common.noResults") }}
    </template>
  </JoszakiAutocomplete>
</template>

<script>
import { ref } from "@nuxtjs/composition-api";
import { usePartnerActions } from "~/components/_refactored/conductor/partners/usePartnerActions";

export default {
  props: {
    value: {
      type: [Object, Array],
      default: null,
    },
  },
  setup(_props, { emit }) {
    const { getPartners } = usePartnerActions();
    const filteredPartners = ref([]);
    const loading = ref(false);

    const onSearch = async (search) => {
      loading.value = true;
      const { items } = await getPartners({
        search,
        page: 1,
        pageSize: 15,
      });
      filteredPartners.value = items;
      loading.value = false;
    };

    const onFocus = (search) => {
      onSearch(search ?? "");
      emit("focus", search);
    };

    return {
      filteredPartners,
      onSearch,
      onFocus,
      loading,
    };
  },
};
</script>
